import { connect } from "react-redux";

var AddStudentsMethodSelect = require("components/org/roster_upload/AddStudentsMethodSelect");
var ManualAddStudents = require("components/org/roster_upload/ManualAddStudents");
var AddStudentsClassCode = require("components/org/roster_upload/AddStudentsClassCode");
var UploadStudentRoster = require("components/org/roster_upload/UploadStudentRoster");
var LoadingButton = require("components/utility/LoadingButton");

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var GoogleSync = require("components/org/roster_upload/GoogleSync");
var CleverSync = require("components/org/roster_upload/CleverSync");

@connect(
	(state, props) => {
		var studentLists = RosterSelectors.nonEmptyStudentLists({ state });

		var methodOptions = ALL_METHOD_OPTIONS;

		if (studentLists.length > 0 && studentLists[0].prefs && studentLists[0].prefs["rostering_method"]) {
			const rosteringPrefs =  studentLists[0].prefs["rostering_method"]

			if (rosteringPrefs && !_.isEmpty(rosteringPrefs)) { // ONLY FREE USERS SHOULD HAVE EMPTY ROSTERING PREFERENCE
				if ( rosteringPrefs["manager"] == "individual") { // IF METHOD USED DELGATES ROSTERING TO TEACHERS
					switch(rosteringPrefs["method"]) {
						case "clever":
							methodOptions = INDIVIDUAL_CLEVER_METHODS;
						break;
						case "google":
							methodOptions = INDIVIDUAL_GOOGLE_METHODS;
						break;
						case "manual":
							methodOptions = INDIVIDUAL_MANUAL_METHODS;
						break;
					}
				} else {
					var methodOptions = [] // REMOVE ALL OPTIONS
				}
			}
		}
				 
		if (!CurrentUser.isTeacherAdmin()) {
			methodOptions = _.without(methodOptions, GOOGLE);
			methodOptions = _.without(methodOptions, CLEVER);
		}

		if (!(CurrentUser.isTeacherAdmin() || CurrentUser.isWizard())) {
			methodOptions = _.without(methodOptions, UPLOAD);
		}

		// // remove Google if using Clever, otherwise remove Clever
		// if (CurrentUser.isCleverSSOUser()) {
		// 	methodOptions = _.without(methodOptions, GOOGLE);
		// } else {
		// 	methodOptions = _.without(methodOptions, CLEVER);
		// }

		// also remove Google & clever option for non teacherAdmins

		return {
			methodOptions, studentLists,
			effectiveUserID: CurrentUser.get().id
		}
	},
	(dispatch, props) => ({})
)

class AddRosterStudents extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var mode = $wr.getURLParameterByName('add_student_method') == 'clever' ? 'clever' : null

		this.state = {
			mode: mode, studentCount: 0
		};
	}

	// returns list of student list ids from list of class names
	// used to expand appropriate student lists after adding students
	studentListIDsByClassName(classNames) {
		var { studentLists } = this.props
		if (_.isEmpty(studentLists) || !classNames) { return [] }
		
		var filteredStudentLists = _.filter(studentLists, (sl) => { return _.includes(classNames, sl.name) })
		return _.pluck(filteredStudentLists, 'id')
	}

	changeTab(tabKey) {
		this.setState({ mode: tabKey }, () => {
			$(window).trigger("resize");
		});
	}

	onRosterUploadShowStatus(studentCount) {
		this.setState({ studentCount: studentCount })
	}

	onRosterUpload(studentCount, alreadyLoaded, pendingTask) {
		$(window.document).trigger("onboarding-trigger-add-students");
		this.showUploadNotification(studentCount, alreadyLoaded, pendingTask);

		if (this.refs && this.refs.modal) {
			this.refs.modal.hide();
		}

	}

	showUploadNotification(studentCount, alreadyLoaded, pendingTask) {
		var title = $wr.pluralize("Student", studentCount) + " Added";
		var studentText = studentCount + " student " + $wr.pluralize("account", studentCount);

		if (alreadyLoaded) {
			var text = "You added " + studentText + "!";
		} else {
			var text = "You are adding " + studentText + "! Hang tight, this could take a few minutes.";
		}

		window.wrNotifications.triggerDropDownNotification({
			title: title,
			text: text, icon: "ok-circle"
		}, 4000);

		// This will automatically trigger the notice for manual addition
		window.wrNotifications.loadPendingTask(pendingTask);

		if (this.props.afterCreate) {
			this.props.afterCreate();
		}

	}

	afterCreate(studentCount, fetchImmediately, pendingTask, classNames) {
		var title = $wr.pluralize("Student", studentCount) + " Added";
		var studentText = studentCount + " student " + $wr.pluralize("account", studentCount);

		if (fetchImmediately) {
			var text = "You added " + studentText + "!";
		} else {
			var text = "You are adding " + studentText + "! Hang tight, this could take a few minutes.";
		}

		var studentListIDs = this.studentListIDsByClassName(classNames)
		if (!_.isEmpty(studentListIDs)) {
			$wr.redirect("/roster?expand_sl=" + studentListIDs.join(','));
		}

		// if students were added, complete onboarding checklist item
		if (studentCount > 0) {
			$(window.document).trigger("onboarding-trigger-add-students")
		}

		window.wrNotifications.triggerDropDownNotification({
			title: title, text: text, icon: "ok-circle"
		}, 4000);

		// This will automatically trigger the notice for manual addition
		window.wrNotifications.loadPendingTask(pendingTask);
		if (this.props.afterCreate) {
			this.props.afterCreate();
		}
	}

	// options for adding students
	render() {
		var studentCount = this.state.studentCount;
		var mode = this.state.mode;
		if (mode === MANUAL) {
			var methodContent = (
				<ManualAddStudents
					defaultStudentListID={this.props.defaultStudentListID}
					afterCreate={this.afterCreate}
					onRosterUploadShowStatus={this.onRosterUploadShowStatus} />
			);
			if (studentCount > 0) {
				var loginInfo = (
					<div className="loginMethod">
						<p className="notice">{studentCount} students are being added to your <i>Roster</i>.</p>
						<div>
							<img className="stepsImg" src={require("misc/student-login.gif")} alt="Log into Whooo's Reading" />
							<div className="infoContainer">
								<p className="header">How students log into Whooo's Reading:</p>
								<ol>
									<li>Go to www.whooosreading.org</li>
									<li>Click <b>Log In</b> button (upper right)</li>
									<li>Select <b>Student</b></li>
									<li>Enter login information</li>
								</ol>
								<p>
									If you are unsure how to do this, help your students by following <a href="https://whooosreading.zendesk.com/hc/en-us/articles/115001179552" target="_blank">these login instructions</a>.
								</p>
							</div>
						</div>
					</div>
				)
			}
		} else if (mode === GOOGLE) {
			var methodContent = (
				<GoogleSync onUpload={this.onRosterUpload} currentStudentLists={this.props.studentLists}
					studentCount={this.state.studentCount} />
			)

		} else if (mode === CLEVER) {
			var methodContent = (
				<CleverSync onUpload={this.onRosterUpload} currentStudentLists={this.props.studentLists}
					studentCount={this.state.studentCount} />
			)
		} else if (mode === CODE) {
			var methodContent = (
				<AddStudentsClassCode />
			)
		} else if (mode == UPLOAD) {
			var methodContent = (
				<UploadStudentRoster afterCreate={this.afterCreate}
					effectiveUserID={this.props.effectiveUserID} />
			)
		}

		var addStudentOptions = (
			<AddStudentsMethodSelect methodOptions={this.props.methodOptions}
				onMethodSelect={this.changeTab} selectedOption={this.state.mode} />
		)
		return (
			<div className="addRosterStudents">
				{addStudentOptions}
				{loginInfo}
				{methodContent}
			</div>
		);
	}
};

const MANUAL = "manual";
const CODE = "class-code";
const UPLOAD = "upload";
const GOOGLE = "google-classroom";
const CLEVER = "clever";

var ALL_METHOD_OPTIONS = [MANUAL, CODE, UPLOAD, GOOGLE, CLEVER]
var INDIVIDUAL_CLEVER_METHODS = [CLEVER];
var INDIVIDUAL_GOOGLE_METHODS = [GOOGLE];
var INDIVIDUAL_MANUAL_METHODS = [MANUAL, CODE, UPLOAD]

AddRosterStudents.WrappedComponent.propTypes = StrictPropTypes({
	// From above
	defaultStudentListID: PropTypes.number,
	afterCreate: PropTypes.func,
	effectiveUserID: PropTypes.number,

	// Data from @connect
	methodOptions: PropTypes.array,
	studentLists: PropTypes.array
});

module.exports = AddRosterStudents;


// WEBPACK FOOTER //
// ./modules/components/org/roster/AddRosterStudents.js